import { USER_TYPE, USER_TYPE_NAV_MAPPER } from "~/constants/common.js";

export function useloginSubmit(params) {
  const baseStore = useBaseStore();
  const authStore = useAuthStore();
  const userStore = useUserStore();
  const router = useRouter();
  const { setLocale } = useI18n();
  const localePath = useLocalePath();

  const setEnglishForAdmin = (basicLanguage) => {
    return baseStore.adminMode ? "en" : basicLanguage;
  };

  const handleYarnIdRedirection = async (route) => {
    if (
      route && route.path &&
      route.path.includes("yarn-id")
      || (router.options.history.state.back && router.options.history.state.back.includes("yarn")) 
    ) {
      const {
        data: {
          data: { yarnlogId },
        },
      } = await usePost("/yarn/check", {
        yarnlogId: route?.params?.id || "",
      });
      if (yarnlogId !== route?.params?.id) {
        return {
          ...route,
          params: {
            ...route?.params,
            id: yarnlogId,
          },
        };
      }
    }
    return route;
  };

  const getNavAfterLogin = () => {
    if (
      [USER_TYPE.DEMO, USER_TYPE.GUEST].includes(userStore.type) &&
      baseStore.urlNav
    ) {
      return baseStore.urlNav;
    } else {
      return USER_TYPE_NAV_MAPPER[userStore.type];
    }
  };

  const success = async () => {
    const lang = setEnglishForAdmin(authStore.user.basicLanguage);
    const redirect = await handleYarnIdRedirection(getNavAfterLogin());
    setLocale(lang);
    router.push(localePath(redirect));
  };

  const loginAdminSite = async (params) => {
    try {
      await authStore.login({
        ...params
      });
      await success();
      return true;
    } catch (err) {
      return err._data
    }
  };
  
  return {
    loginAdminSite
  };
}
